import { gql } from '@apollo/client'

const DELETE_POLICY_CLASS = gql`
  mutation DELETE_POLICY_CLASS($policyClass: ID!) {
    deletePolicyClass(policyClass: $policyClass) {
      id
      name
    }
  }
`

export default DELETE_POLICY_CLASS
